import MultiSelectCardView from './MultiSelectCard.view';
export default MultiSelectCardView;
